import {IRMACapitalService} from "@/services/irmacapital.service";

const state ={
    loading: false,
    viewstate:-1,
    dialog:false,
    reqloan:{
        name:'',
        noktp: '',
        alamat: '',
        phone:'+62',
        imagektp: '',
        imageselfie : '',
        imagebusiness: '',
        businessname:'',
        businessphone:'+62',
        businesswebsite:'www.',
        jenisusaha: 0,
        businessaddress:'',
        businessprovince: '',
        businesscity: '',
        businessdistrict: '',
        businessyear: 2020,
        businesscapital: 0,
        businessturnover: 0,
        businessprofit: 0,
        businesscustomer:0,
        provinsi: {},
        city:{},
        district: [],
        msg:'',

    },
    loan: {
        limit: 50000000,
        used: 25000000,
        progress: 50,
        duedate: "2020/10/1",
        status: 1
    },
    setting:{
      fee: 0.015,
      admin:0,
      periode: 30
    },
    contract: [
        {
            contractid:"asdjasjdk123123",
            amount: 10000000,
            reqdate: "2020/09/02",
            duedate: "2020/10/02",
        }
    ],
    total_contract:0,
    repayment: [],
    total_repayment:0

}
const actions ={

    setviewstate({commit},vstate){
        commit('setviewstate', vstate);
    },
    closedialog({commit}){
        commit('setdialog', false);
    },
    opendialog({commit}){
        commit('setdialog', true);
    },
    getSettings({commit}){
        IRMACapitalService.getSettings().then(value => {
            commit('setsettingdata', value);
        }).catch(e=>{
            console.log(e);
        });
    },
    getLoan({commit}){
        commit('setloading', true);
        IRMACapitalService.getLoan().then(value => {
            commit('setloading', false);
            commit('setloandata', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
    doCreateContract({dispatch,commit},data){
        commit('setloading', true);
        IRMACapitalService.createContract(data).then(data => {
            commit('setloading', false);
            commit('setdialog', false);
            dispatch('alert/success', data.msg, { root: true });
        }).catch(error=>{
            commit('setloading', false);
            dispatch('alert/error', error, { root: true });
            console.log(error);
        });
    },
    doRequestCapital({dispatch,commit},data){
        commit('setloading', true);
        IRMACapitalService.doRequestCapital(data).then(data => {
            commit('setloading', false);
            dispatch('alert/success', data.msg, { root: true });
            commit('setloading', true);
            IRMACapitalService.getLoan().then(value => {
                commit('setloading', false);
                commit('setloandata', value);
            }).catch(e=>{
                commit('setloading', false);
                console.log(e);
            });
        }).catch(error=>{
            commit('setloading', false);
            dispatch('alert/error', error, { root: true });
            console.log(error);
        });
    },
    doRepayment({dispatch,commit},data){
        commit('setloading', true);
        IRMACapitalService.doRepayment(data).then(data => {
            commit('setloading', false);
            dispatch('alert/success', data.msg, { root: true });
        }).catch(error=>{
            commit('setloading', false);
            dispatch('alert/error', error, { root: true });
            console.log(error);
        });
    },
    getRepayment({commit},opt){
        commit('setloading', true);
        IRMACapitalService.getRePayments(opt).then(value => {
            commit('setloading', false);
            commit('setrepaymentdata', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
    getContracts({commit},opt){
        commit('setloading', true);
        IRMACapitalService.getContracts(opt).then(value => {
            commit('setloading', false);
            commit('setcontractdata', value);
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
    getReqData({dispatch,commit}){
        commit('setloading', true);
        IRMACapitalService.getRequestCapitaldata().then(value => {
            commit('setloading', false);
            commit('setreqdata', value);
            console.log(value);
            if(value.success){
                console.log(value.data);
                dispatch("Location/getCity",{province_id:value.data.businessprovinceid},{ root: true })
                dispatch("Location/getKecamatan",{city_id:value.data.businesscityid},{ root: true })
            }
        }).catch(e=>{
            commit('setloading', false);
            console.log(e);
        });
    },
}


const mutations ={
    setimagektp(state,v){
        state.reqloan.imagektp=v;
    },
    setimageselfie(state,v){
        state.reqloan.imageselfie=v;
    },
    setimagebusiness(state,v){
        state.reqloan.imagebusiness=v;
    },
    setProvince(state,v){
        state.reqloan.businessprovince=v.province
        state.reqloan.businessprovinceid=v.province_id

    },
    setCity(state,v){
        state.reqloan.businesscity=v.city_name
        state.reqloan.businesscityid=v.city_id
    },
    setKecapatan(state,v){
        state.reqloan.businessdistrict=v.subdistrict_name
        state.reqloan.businessdistrictid=v.subdistrict_id
    },
    setloading(state,load){
        state.loading=load;
    },
    setdialog(state,x){
        state.dialog=x;
    },
    setviewstate(state,vstate){
        state.viewstate=vstate;
    },
    setloandata(state,v){
        console.log(v.data);
        state.loan=v.data.loan;
        state.loan.used=v.data.used;
        if(v.data.loan.status===0){
            state.viewstate=0;
        }
        if(v.data.loan.status===1){
            state.viewstate=2;
        }
        if(v.data.loan.status===9){
            state.viewstate=9;
        }
        if(v.data.loan.status===8){
            state.viewstate=1;
        }
        state.loan.progress=100-(v.data.used/v.data.loan.creditlimit)*100;
    },
    setcontractdata(state,v){
        console.log(v.data.content);
        state.contract=v.data.content;
        state.total_contract=v.data.totalElements
    },
    setrepaymentdata(state,v){
        state.repayment=v.data.content;
        state.total_repayment=v.data.totalElements
    },
    setsettingdata(state,v){
        state.setting=v.data;
    },
    setreqdata(state,v){
        state.reqloan=v.data;
        state.reqloan.provinsi={
            "province_id": v.data.businessprovinceid,
            "province": v.data.businessprovince }
        state.reqloan.city={
            "city_id": v.data.businesscityid,
            "city_name": v.data.businesscity
        }
        state.reqloan.district={
            subdistrict_id:v.data.businessdistrictid,
            subdistrict_name: v.data.businessdistrict
        }
    }
}

export const Loan = {
    namespaced: true,
    state,
    actions,
    mutations
};
